<script lang="ts">
  import type { IconsBaseProps } from './icons.types.ts';

  let { class: className, size = 6, title, ...rest }: IconsBaseProps = $props();
</script>

<svg viewBox="0 0 24 24" {...rest} width={size * 4} height={size * 4} class={className}>
  {#if title}<title>{title}</title>{/if}
  <path
    opacity="0.9"
    d="M23.1093 17.2034C23.42 17.2034 23.6733 16.9514 23.6583 16.6411C23.569 14.7884 23.0391 12.9807 22.1093 11.3695C21.0857 9.59569 19.6133 8.12241 17.8401 7.09766L14.2192 13.3632C14.8931 13.7526 15.4525 14.3124 15.8415 14.9865C16.1365 15.4976 16.3255 16.0607 16.3997 16.6423C16.439 16.9505 16.6871 17.2034 16.9978 17.2034H23.1093Z"
    fill="#E0E0E0"
  /><path
    opacity="0.9"
    d="M17.8359 7.09498C16.0622 6.07098 14.0504 5.53168 12.0024 5.53125C9.95435 5.53082 7.94227 6.06928 6.16821 7.09254L9.78387 13.3611C10.458 12.9723 11.2226 12.7676 12.0008 12.7678C12.7791 12.768 13.5436 12.9729 14.2176 13.362L17.8359 7.09498Z"
    fill="#E0E0E0"
  /><path
    opacity="0.9"
    d="M6.1641 7.09473C4.39047 8.11873 2.9175 9.59139 1.89312 11.3648C0.962672 12.9756 0.432075 14.783 0.34195 16.6357C0.326856 16.946 0.580004 17.1981 0.890665 17.1982L7.00223 17.2008C7.31289 17.2009 7.56116 16.9482 7.60058 16.64C7.67499 16.0584 7.86426 15.4954 8.15941 14.9844C8.54867 14.3105 9.1084 13.7509 9.78238 13.3618L6.1641 7.09473Z"
    fill="#FC7D8D"
  /><path
    opacity="0.9"
    d="M14.2192 13.3632L17.8401 7.09766"
    stroke="#8A8A8A"
    stroke-width="0.25"
  /><path
    opacity="0.9"
    d="M9.78234 13.3618L6.16406 7.09473"
    stroke="#8A8A8A"
    stroke-width="0.25"
  /><path
    d="M4.62652 12.2515C4.22651 12.085 3.90583 12.6214 4.24191 12.8949L10.979 18.3773C11.7465 19.0018 12.8925 18.7933 13.4051 17.936L-nan -nanL13.4051 17.936C13.9176 17.0786 13.5586 15.9705 12.6452 15.5901L4.62652 12.2515Z"
    fill="#4F4F4F"
  />
</svg>
